import React, { Component } from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";
// import "./Modal.scss";
// styled
import StyledModal from "./Modal.css";
const modalRoot = document.getElementById("modal-root");

class Modal extends Component {
  static defaultProps = {
    id: "",
    modalClass: "",
    modalSize: "md",
    openModal: false,
  };
static propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalClass: PropTypes.string,
    modalSize: PropTypes.string
  };
state = { fadeType: null };
background = React.createRef();
componentDidMount() {
    window.addEventListener("keydown", this.onEscKeyDown, false);
    setTimeout(() => this.setState({ fadeType: "in" }), 0);
  }
componentDidUpdate(prevProps, prevState) {
    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({ fadeType: "out" });
    }
  }
componentWillUnmount() {
    window.removeEventListener("keydown", this.onEscKeyDown, false);
  }
transitionEnd = e => {
    if (e.propertyName !== "opacity" || this.state.fadeType === "in") return;
if (this.state.fadeType === "out") {
      this.props.onClose();
    }
  };
onEscKeyDown = e => {
    if (e.key !== "Escape") return;
    this.setState({ fadeType: "out" });
  };
handleClick = e => {
    e.preventDefault();
    this.setState({ fadeType: "out" });
  };
hideNotificationModal =()=>{
  this.setState({openModal:false});
}

render() {
  console.log('this.props',this.props)
    return ReactDom.createPortal(
      <StyledModal
        id={this.props.id}
        className={`wrapper ${this.props.class}`}
        role="dialog"
        modalSize={this.props.size}
        onTransitionEnd={this.transitionEnd}
        fadeType={this.state.fadeType}
      >
        <div className="box-dialog" style={{ width: '100%',height: '100%',padding: '16px'}}>
          <div className="box-header">
            {/* <h4 className="box-title">Title Of Modal</h4> */}
            <button onClick={this.props.onClose} className="close" style={{fontSize: 'xx-large'}}>
              ×
            </button>
          </div>
          <div className="box-content" style={{height: '90%', width: '100%', padding: '25px'}}>{this.props.children}</div>
        </div>
        <div
          className={`background`}
          onMouseDown={this.handleClick}
          ref={this.background}
        />
      </StyledModal>,
      modalRoot
    );
  }
}
export default Modal;